import React from "react";

import { Icomponent } from "../../../core/components/basegame/interface/Icomponent";


interface IframeworkMultiplier {
    data: {
        COMPONENTS: Icomponent[]
    }

}

export const frameworkMultiplier: IframeworkMultiplier = {

    data: {
        "COMPONENTS": [


            {
                "id": "desktopMainContainer",
                "name": "desktopMainContainer",
                "type": "Container",
                "class": "",
                "x": 0,
                "y": 0,
                "layout": false,
                "uimode": "desktop",
                "filterTypes": [],
                "parentLayer": "baseLayer",
                child: [

                    {
                        "id": "multiplierText_1_desktop",
                        "name": "multiplierText_1_desktop",
                        "type": "BitMapText",
                        "x": 188, //188
                        "y": 302,
                        // "height": 100,
                        "width": 440,
                        "text": "text1",
                        visible: true,
                        "scaleToFit": true,
                        "anchor": [0.5, 0.5],
                        "textStyle": {
                            font: '80px otal_win_value-export',
                        },
                    },
                    {
                        "id": "multiplierText_2_desktop",
                        "name": "multiplierText_2_desktop",
                        "type": "BitMapText",
                        "x": 188, //188
                        "y": 402,//402
                        // "height": 100,
                        "width": 440,
                        "text": "text2",
                        visible: true,
                        "scaleToFit": true,
                        "anchor": [0.5, 0.5],
                        "textStyle": {
                            font: '80px otal_win_value-export',
                        },
                    },
                    {
                        "name": "multiplier_overlay",
                        "type": "Graphic",
                        "shape": "rectangle",
                        "visible": false,
                        "alpha": 0.6,
                        "color": "0x000000",
                        "x": 0,
                        "y": 0,
                        "width": 1920,
                        "height": 600,
        
                    },
                    

                ]
            },
            {
                "id": "mobileMainContainer",
                "name": "mobileMainContainer",
                "type": "Container",
                "class": "",
                "x": 0,
                "y": 4,
                "layout": true,
                "uimode": "mobile",
                "filterTypes": [],
                "parentLayer": "baseLayer",
                child: [
                    {
                        "id": "multiplierText_1_desktop",
                        "name": "multiplierText_1_desktop",
                        "type": "BitMapText",
                        "x": 188, //188
                        "y": 291,
                        // "height": 100,
                        "width": 440,
                        "text": "text1",
                        visible: true,
                        "scaleToFit": true,
                        "anchor": [0.5, 0.5],
                        "textStyle": {
                            font: '80px otal_win_value-export',
                        },
                    },
                    {
                        "id": "multiplierText_2_desktop",
                        "name": "multiplierText_2_desktop",
                        "type": "BitMapText",
                        "x": 188, //188
                        "y": 391,//402
                        // "height": 100,
                        "width": 440,
                        "text": "text2",
                        visible: true,
                        "scaleToFit": true,
                        "anchor": [0.5, 0.5],
                        "textStyle": {
                            font: '80px otal_win_value-export',
                        },
                    },

                ]
            },

            
        ],
    }

};

export const MultiplierConfigurationContext = React.createContext(
    {}
);